import { useState } from "react"
import { CellContext } from "@tanstack/react-table"
import styled, { css } from "styled-components"

import { ApiTypes, UITypes } from "types"

import { isSerializedProductType } from "utils/productType"
import { TrackPackageModal } from "modals/TrackPackageModal"

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const OrderNumber = styled.span<{ isSubRow?: boolean }>`
  color: #0f172a;
  min-width: 20px;
  padding-left: ${props => (props.isSubRow ? "12px" : "0")};
`

const TrackPackageLink = styled.span<{ disabled?: boolean }>`
  color: #2db2c8;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: #64748b;
      cursor: not-allowed;
      text-decoration: none;

      &:hover {
        opacity: 1;
      }
    `}
`

interface OrderNumberCellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const OrderNumberCell = ({ cell }: OrderNumberCellProps) => {
  const [showTrackPackageModalLocal, setShowTrackPackageModalLocal] = useState(false)

  const orderItem = cell.row.original.rowSettings.item[0]
  const orderNumber = cell.row.original.rowSettings.item[0].id
  const showOrderNumber = !!cell.row.parentId || cell.row.original.subRows?.length === 0
  const showDetails = ["packed", "shipping", "archived"].includes(orderItem.status)

  const items = cell.row.original.rowSettings.item

  const allTrackingNumbers = Array.from(
    new Set(
      items.reduce((acc: number[], item: ApiTypes.Model.OrderNewItem) => {
        acc.push(...item.tracking_numbers)
        return acc
      }, []),
    ),
  ) as number[]

  const hasTrackingNumbers = allTrackingNumbers.length > 0

  const handleTrackPackageClick = () => {
    if (hasTrackingNumbers) {
      setShowTrackPackageModalLocal(true)
    }
  }

  const isClickable = showDetails && showOrderNumber
  const tooltipId = `order-devices-${orderNumber}`

  return (
    <>
      <Container>
        <OrderNumber
          data-tooltip-id={isClickable && isSerializedProductType(orderItem.product_type) ? tooltipId : undefined}
        >
          {showOrderNumber ? orderNumber : ""}
        </OrderNumber>
        {isClickable && (
          <TrackPackageLink disabled={!hasTrackingNumbers} onClick={handleTrackPackageClick}>
            Track Package
          </TrackPackageLink>
        )}
      </Container>
      {showTrackPackageModalLocal && (
        <TrackPackageModal onCancel={() => setShowTrackPackageModalLocal(false)} trackingNumbers={allTrackingNumbers} />
      )}
    </>
  )
}

export default OrderNumberCell
